import styled from 'styled-components';

/**
 * The wheel is the only element that flexes with the viewport.
 *
 * Everything else in the modal has a fixed height, so a short window has to be absorbed
 * here or the modal overflows. `min()` keeps the original pixel size as the ceiling —
 * on a tall screen it is exactly as big as before — and falls back to a share of the
 * viewport when there is not room for that. `vw` is in the list so narrow phones clamp
 * on width rather than running off the side.
 */
export const RouletteContainer = styled.div`
  width: min(300px, 40vh, 88vw);
  height: min(300px, 40vh, 88vw);
  position: relative;
  object-fit: contain;
  z-index: 5;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: 768px) {
    width: min(445px, 46vh, 88vw);
    height: min(445px, 46vh, 88vw);
  }

  @media screen and (min-width: 1280px) {
    width: min(600px, 52vh, 88vw);
    height: min(600px, 52vh, 88vw);
  }
`;

export const RotationContainer = styled.div<{
  $classKey: string;
  $startSpinningTime: number;
  $continueSpinningTime: number;
  $stopSpinningTime: number;
  $startRotationDegrees: number;
  $finalRotationDegrees: number;
}>`
  width: 100%;
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(${({ $startRotationDegrees }) => $startRotationDegrees}deg);

  &.started-spinning {
    // prettier-ignore
    animation: spin-${({ $classKey }) => $classKey} ${({ $startSpinningTime }) =>
      $startSpinningTime / 1000}s cubic-bezier(0.71, 0, 0.96, 0.9) 0s 1 normal forwards running,
      // prettier-ignore
    continueSpin-${({ $classKey }) => $classKey} ${({ $continueSpinningTime }) => $continueSpinningTime / 1000}s linear ${({
      $startSpinningTime,
    }) => $startSpinningTime / 1000}s 1 normal forwards running,
      // prettier-ignore
    stopSpin-${({ $classKey }) => $classKey} ${({ $stopSpinningTime }) =>
      $stopSpinningTime / 1000}s cubic-bezier(0, 0, 0.35, 1.02) ${({ $startSpinningTime, $continueSpinningTime }) =>
      ($startSpinningTime + $continueSpinningTime) / 1000}s 1 normal forwards running;
  }

  @keyframes spin-${({ $classKey }) => $classKey} {
    from {
      transform: rotate(${({ $startRotationDegrees }) => $startRotationDegrees}deg);
    }
    to {
      transform: rotate(${({ $startRotationDegrees }) => 360 + $startRotationDegrees}deg);
    }
  }
  @keyframes continueSpin-${({ $classKey }) => $classKey} {
    from {
      transform: rotate(${({ $startRotationDegrees }) => $startRotationDegrees}deg);
    }
    to {
      transform: rotate(${({ $startRotationDegrees }) => 360 + $startRotationDegrees}deg);
    }
  }
  @keyframes stopSpin-${({ $classKey }) => $classKey} {
    from {
      transform: rotate(${({ $startRotationDegrees }) => $startRotationDegrees}deg);
    }
    to {
      transform: rotate(${({ $finalRotationDegrees }) => 1440 + $finalRotationDegrees}deg);
    }
  }
`;
